/* global CONFIG */
module.exports = function () {
  this.app.$on('loginToken', event => {
    this.sdk.get('/me', { token: event.token }, (response) => {
      if (response.success && response.data && response.data.ID) {
        response.data.bday = response.data.dateOfBirth
        response.data.country = response.data.userCountry
        this.sdk.get('/me/phones', { token: event.token }, (phonesResponse) => {
          if (phonesResponse.success) {
            if (phonesResponse.data.length > 0) {
              response.data.phone = phonesResponse.data[0].phoneNumber
              response.data.countryCode = phonesResponse.data[0].countryCode

              let nonUSMobile = response.data.countryCode === 1
              this.app.$emit('mobileCCUpdate', { isUS: nonUSMobile })
            } else {
              response.data.countryCode = ''
            }
          } else {
            response.data.countryCode = ''
          }
          this.session.useToken(event.token)
          this.app.user = response.data
          event.callback(response.data)
        })

        if (response.data.corporateProfile && response.data.corporateProfile.discountCode) {
          this.app.$emit('redeemCode', {code: response.data.corporateProfile.discountCode})
        }

        response.token = event.token
        this.app.$emit('loginTokenSuccess', response)

        if (window.fcWidget) {
          let store = this.app.$children[0].$store
          // let user = store.state.user
          window.fcWidget.init({
            token: '4bdadd95-c9ee-4672-898c-70d1e4129b77',
            host: 'https://wchat.freshchat.com',
            externalId: response.data.ID,
            tags: ['widget']
          })
          let currentBrand = ''
          for (let brand in CONFIG.Brands) {
            if (CONFIG.Brands[brand].id === store.state.brandId) {
              currentBrand = CONFIG.Brands[brand].name
            }
          }
          let userObject = {
            firstName: response.data.firstName,
            lastName: response.data.lastName,
            email: response.data.email,
            phoneNumber: response.data.phone,
            countryCode: '+' + response.data.countryCode,
            userId: response.data.ID,
            is_consumer: true,
            platform: 'web',
            brand: currentBrand
          }
          window.fcWidget.user.get(function (resp) {
            let status = resp && resp.status
            if (status !== 200) {
              window.fcWidget.user.setProperties(userObject)
              window.fcWidget.on('user:created', function (resp) {
                let status = resp && resp.status
                let data = resp && resp.data;
                if (status === 200) {
                  if (data.restoreId) {
                     // Update restoreId in your database
                  }
                }
              })
            }
          })
        }
      } else {
        // existing token fails, generaate a new guest token
        this.session.generateGuestToken()
        event.callback(false)
      }
    })
  })

  this.app.$on('generateToken', callback => {
    callback(this.session.generateUserToken(false))
  })
  this.app.$on('generateToken2', callback => {
    callback(this.session.generateUserToken(false))
  })
}



// WEBPACK FOOTER //
// ./src/events/token.js